<script setup>
import FormContainer from "@/Pages/Components/FormContainer.vue";

defineProps({
    form: {
        type: Object,
        default: {}
    }
})

const titles = [
    'Mr.',
    'Mrs.',
    'Miss.',
    'Ms.',
    'Dr.',
]
</script>

<template>
    <FormContainer title="Your details" >
        <v-row>
            <v-col cols="12">
                <v-select v-model="form.title" label="Title" :items="titles" item-value="id" item-title="name"/>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="form.forename" label="First Name *" :error-messages="form.errors.forename"/>
            </v-col>
            <v-col cols="12">
                <v-text-field  v-model="form.surname" label="Last Name *" :error-messages="form.errors.surname"/>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="form.phoneNumber" label="Phone number *" :error-messages="form.errors.phoneNumber"/>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="form.email" label="Email *" :error-messages="form.errors.email"/>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="form.postcode" label="Postcode *" :error-messages="form.errors.postcode"/>
            </v-col>
        </v-row>
    </FormContainer>
</template>

<style scoped>

</style>
